import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RatingWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      hoverVal: null,
    };
    this.onHoverOrFocus = this.onHoverOrFocus.bind(this);
    this.onBlurOrMouseLeave = this.onBlurOrMouseLeave.bind(this);
  }

  onHoverOrFocus(hoverVal) {
    if (!this.props.disabled) {
      this.setState({
        hover: true,
        hoverVal,
      });
    }
  }

  onBlurOrMouseLeave() {
    if (!this.props.disabled) {
      this.setState({
        hover: false,
        hoverVal: null,
      });
    }
  }

  render() {
    const { children } = this.props;
    return (
      <ul className="srv-q-rtg unstyled">
        {children({
          ...this.state,
          onHoverOrFocus: this.onHoverOrFocus,
          onBlurOrMouseLeave: this.onBlurOrMouseLeave,
        })}
      </ul>
    );
  }
}

RatingWrapper.propTypes = {
  children: PropTypes.func,
};
